
import React from 'react';
import { format } from 'date-fns';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { ClientRefundApprovalActions } from '../ClientRefundApprovalActions';
import { Appointment } from '../types/appointmentTypes';

interface PendingRefundRequestsProps {
  appointments: Appointment[];
  onStatusUpdate: () => void;
}

export const PendingRefundRequests: React.FC<PendingRefundRequestsProps> = ({
  appointments,
  onStatusUpdate
}) => {
  const pendingRefundAppointments = appointments.filter(a => a.refund_status === 'pending_user_approval');
  
  if (pendingRefundAppointments.length === 0) {
    return null;
  }
  
  return (
    <div className="mt-8 space-y-6">
      <h3 className="text-xl font-medium">Pending Refund Requests</h3>
      <div className="space-y-4">
        {pendingRefundAppointments.map(appointment => (
          <Card key={`refund-${appointment.id}`} id={`refund-approval-${appointment.id}`}>
            <CardHeader>
              <CardTitle className="text-lg">
                Refund Request: {appointment.service.service_name}
              </CardTitle>
              <CardDescription>
                Appointment on {format(new Date(appointment.start_time), 'MMMM d, yyyy')} at {format(new Date(appointment.start_time), 'h:mm a')}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ClientRefundApprovalActions
                bookingId={appointment.id}
                refundReason={appointment.refund_reason || 'No reason provided'}
                onStatusUpdate={onStatusUpdate}
              />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
